import { ReactNode, useEffect, useState } from "react";
import { Container } from "reactstrap";
import { EnvironmentSettings, IEnvironmentSettings, } from "../../utility/EnvironmentHelper";
import Header from "./_Header";
import "./Layout.css";
import PageContent from "../../components/common/VFX-UI/PageContent/PageContent";
import SideBar from "./_SideBar";
import {
    IsOrganizationDonor,
    IsOrganizationUser,
    IsCauwUser,
} from "../../utility/helpers/claimHelper";
import { useLocation } from "react-router-dom";

const Layout = ({ children }: { children: ReactNode }) => {
    const environmentSettings: IEnvironmentSettings = EnvironmentSettings();
    const location = useLocation();
    const hideSidebar = location.pathname.startsWith("/pledge");
    const shouldShowSidebar =
        !hideSidebar && (IsOrganizationUser() || IsCauwUser() || IsOrganizationDonor());

    // The sidebar becomes part of the header menu on mobile.
    const [contentLeftMargin, setContentLeftMargin] = useState<number>(() => {
        if (!shouldShowSidebar) return 0;
        if (typeof window !== "undefined" && window.innerWidth < 576) return 0;
        return 275; // desktop sidebar space (includes padding)
    });

    useEffect(() => {
        function updateMargin() {
            if (!shouldShowSidebar) {
                setContentLeftMargin(0);
                return;
            }
            const isMobile = window.innerWidth < 576;
            setContentLeftMargin(isMobile ? 0 : 275);
        }

        updateMargin();
        window.addEventListener("resize", updateMargin);
        return () => window.removeEventListener("resize", updateMargin);
    }, [shouldShowSidebar]);

    return (
        <div className="App">
            <Header
                environmentName={environmentSettings.environmentName}
                displayEnvironmentBar={environmentSettings.displayEnvironmentBar}
                showSideNavigation={shouldShowSidebar}
            />

            <Container id="header-spacer" style={{ height: environmentSettings.headerHeight, display: "block", margin: 0, }} />
            {shouldShowSidebar && (
                <div className="bg-light flex-fill sidebar pl-2 pt-3">
                    <SideBar />
                </div>
            )}
            <div
                style={{ marginLeft: contentLeftMargin }}
                className={`pt-3${shouldShowSidebar ? " layout-content-with-sidebar" : ""}`}
            >
                <PageContent>{children}</PageContent>
            </div>
        </div>
    );
};

export default Layout;
